import angular from 'angular';
import angularBootstrapNpm from 'angular-ui-bootstrap';
import i18n from '../i18n';
import utils from '../utils';
import contentPanelDirective from './content-panel-directive';
import contentPanelHeaderDirective from './content-panel-header-directive';
import contentPanelBodyDirective from './content-panel-body-directive';

/**
 * @ngdoc module
 * @name akamai.components.content-panel
 *
 * @guideline https://design.akamai.com/components/content-panel/
 *
 * @description
 * Content-panel is a building block of most user interfaces. Besides containing components,
 * panels themselves can be placed within containers, which allows for orderly layouts.
 * Panels can contain toolbars at the top or bottom of the panel, with separate header,
 * footer, and body sections.
 *
 * @example index.html
 * <akam-content-panel header="Panel Title">
 *   Panel Body
 * </akam-content-panel>
 *
 * <!-- Or this if you need custom markup in your header: -->
 * <akam-content-panel>
 *   <akam-content-panel-header><b>Panel</b> Title</akam-content-panel-header>
 *   <akam-content-panel-body>Panel Body</akam-content-panel-body>
 * </akam-content-panel>
 */
export default angular.module('akamai.components.content-panel', [
  angularBootstrapNpm,
  i18n.name,
  utils.name
])

/**
 * @ngdoc directive
 * @name akamContentPanel
 * @description Creates a content panel control.
 *
 * @restrict E
 *
 * @param {boolean} [is-collapsed=false] If true, content-panel will be rendered in a collapsed
 * state
 *
 * @param {string} [header] The panel header
 *
 * @param {function(boolean)} [on-toggle] A function that will be called when content-panel is
 * expanded or collapsed. The function will be passed `value` as an argument. If `value` is true,
 * the content-panel is collapsed. If `value` is false, the content-panel is expanded.
 *
 * @param {*} [not-collapsable] If present, the content-panel will not be collapsable.
 *
 */
  .directive('akamContentPanel', contentPanelDirective)

/**
 * @name akamContentPanelHeader
 *
 * @description Use inside of an `<akam-content-panel>` directive to specify panel header markup.
 * Do not use the `header` attribute on `<akam-content-panel>` if you use this directive.
 *
 * @restrict E
 */
  .directive('akamContentPanelHeader', contentPanelHeaderDirective)

/**
 * @name akamContentPanelBody
 *
 * @description Use inside of an `<akam-content-panel>` directive to specify panel body markup.
 * Do not use the `header` attribute on `<akam-content-panel>` if you use this directive.
 *
 * @restrict E
 */
  .directive('akamContentPanelBody', contentPanelBodyDirective);
